import apiService from "./api";

const limitService = {
  // Get all limits for a company
  getCompanyLimits(params) {
    return apiService.get(`/limits`, params);
  },

  // Get single limit
  getLimit(limitId) {
    return apiService.get(`/limits/${limitId}`);
  },

  // Create new limit
  createLimit(data) {
    return apiService.post(`/limits`, data);
  },

  // Delete limit
  deleteLimit(limitId) {
    return apiService.delete(`/limits/${limitId}`);
  },

  // Duplicate limit
  duplicateLimit(limitId) {
    return apiService.post(`/limits/${limitId}/duplicate`);
  },

  // Toggle limit status
  toggleLimitState(limitId, state) {
    return apiService.put(`/limits/${limitId}/state`, {
      state,
    });
  },

  // Update complete limit params in one request
  updateLimitParams(limitId, payload) {
    return apiService.put(`/limits/${limitId}/params`, payload);
  },

  // Update timing parameters
  updateTiming(limitId, timingData) {
    return apiService.put(`/limits/${limitId}/params/timing`, timingData);
  },

  // Update limit definition
  updateLimitDefinition(limitId, definitionData) {
    return apiService.put(`/limits/${limitId}/params/limit_definition`, definitionData);
  },

  // Update ordering rules
  updateOrderingRules(limitId, orderingData) {
    return apiService.put(`/limits/${limitId}/params/ordering_rules`, orderingData);
  },

  // Update payment logic
  updatePaymentLogic(limitId, paymentData) {
    return apiService.put(`/limits/${limitId}/params/payment_logic`, paymentData);
  },

  // Update rollover policy
  updateRolloverPolicy(limitId, rolloverData) {
    return apiService.put(`/limits/${limitId}/params/rollover_policy`, rolloverData);
  },

  // Get current credit state for a user by limit
  getCurrentUserLimitState(userId) {
    return apiService.get(`/limits/transactions/current-state`, {
      user_id: userId,
    });
  },

  // Get transactions for a limit
  getLimitTransactions(limitId) {
    return apiService.get(`/limits/${limitId}/transactions`);
  },

  // Get all credit transactions for a company
  getCompanyTransactions(companyId, params = {}) {
    return apiService.get(`/limits/transactions/company/${companyId}`, params);
  },

  // Fetches all pages of limits and returns a flat array of all items
  async getAllLimits(params = {}) {
    const firstResponse = await apiService.get("/limits", { ...params, page: 1 });
    const firstData = firstResponse?.data?.data || [];
    const lastPage = firstResponse?.data?.last_page || 1;
    if (lastPage <= 1) return firstData;
    const pageRequests = [];
    for (let page = 2; page <= lastPage; page++) {
      pageRequests.push(apiService.get("/limits", { ...params, page }));
    }
    const responses = await Promise.all(pageRequests);
    return [...firstData, ...responses.flatMap((r) => r?.data?.data || [])];
  },
};

export default limitService;
